import * as Plot from "@observablehq/plot";
import { useEffect, useRef } from 'react'

function IndlagtePlotMini({ data, type }) {
  const ref = useRef(null);

  const aMonthAgo = () => {
    const d = new Date()
    d.setDate(d.getDate() - 30);
    return d
  }

  useEffect(() => {
    const plot = Plot.plot({
      y: {
        grid: true,
        label: null,
        //percent: type !== "actual"
      },
      marks: [
        type === "actual" ? Plot.line(
          data.filter((d) => d.date > aMonthAgo()).sort((a, b) => a.date - b.date),
          { x: "date", y: type === "actual" ? "currentHospitalized" : d => d.currentHospitalized / d.currentHospitalized , stroke: "steelblue"}
        ) : null,
        Plot.line(
          data.filter((d) => d.date > aMonthAgo()).sort((a, b) => a.date - b.date),
          { x: "date", y: type === "actual" ? "currentIntensive" : d => d.currentIntensive / d.currentHospitalized, stroke: "orange" }
        ),
        Plot.line(
          data.filter((d) => d.date > aMonthAgo()).sort((a, b) => a.date - b.date),
          { x: "date", y: type === "actual" ? "currentRespirator" : d => d.currentRespirator / d.currentHospitalized, stroke: "red" }
        ),
        Plot.ruleY([0])
      ],
      width: 280,
      height: 175
    });
    if (ref.current) {
      if (ref.current.children[0]) {
        ref.current.children[0].remove();
      }
      ref.current.appendChild(plot);
    }
  }, [ref, data, type]);
  return (
    <div style={{ display: "flex", justifyContent: "center" }} ref={ref} />
  )
}

export default IndlagtePlotMini